import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import english from './locales/en';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		debug: false,
		initImmediate: false,
		ns: ['slyce360-translation'],
		defaultNS: 'slyce360-translation',
		react: {
			useSuspense: false,
			wait: true
		},
		resources: {
			en: { 'slyce360-translation': english }
		},
		interpolation: {
			escapeValue: false
		}
	});
